import { Badge, Text } from "@mantine/core";
import TravellerUploadDocCell from "../components/TravellerUploadDocCell/TravellerUploadDocCell";
import { CreatedColumn, JourneyColumn, StatusColumn } from "./policyTableShared";
import { formatGender, getTravellerAge, getTravellerName } from "./allPolicyHelpers";
import PolicyCellStack from "./PolicyCellStack";
import { coverTypeColor } from "./policyTableUtils";

export const buildTravellerTableFields = () => [
  {
    key: "id",
    label: "# / COVER NO.",
    width: 140,
    render: (row) => (
      <PolicyCellStack>
        <Text fw={700} c="orange.6" size="sm">#{row.id}</Text>
        {row.cover_number ? <Text size="xs" c="dimmed" lineClamp={1}>{row.cover_number}</Text> : null}
      </PolicyCellStack>
    ),
  },
  {
    key: "first_name",
    label: "TRAVELLER",
    width: 220,
    render: (row) => {
      const age = getTravellerAge(row.dob);
      return (
        <PolicyCellStack>
          <Text fw={600} size="sm" lineClamp={1}>{getTravellerName(row)}</Text>
          <Text size="xs" c="dimmed" lineClamp={1}>{row.email || "—"}</Text>
          {row.phone_number ? <Text size="xs" c="dimmed">{row.phone_number}</Text> : null}
          {age != null || formatGender(row.gender) ? (
            <Text size="xs" c="dimmed">
              {[age != null ? `Age ${age}` : null, formatGender(row.gender)].filter(Boolean).join(" · ")}
            </Text>
          ) : null}
        </PolicyCellStack>
      );
    },
  },
  {
    key: "trip_id",
    label: "TRIP / COVER",
    width: 240,
    render: (row) => (
      <PolicyCellStack>
        {row.trip_id ? (
          <Text fw={700} c="orange.6" size="xs">Trip #{row.trip_id}</Text>
        ) : null}
        <Text fw={600} size="sm" lineClamp={2}>{row.cover_name || "—"}</Text>
        {row.cover_type ? (
          <Badge size="xs" variant="light" color={coverTypeColor(row.cover_type)}>{row.cover_type}</Badge>
        ) : null}
      </PolicyCellStack>
    ),
  },
  { key: "traveller_from_name", label: "JOURNEY", width: 210, render: (row) => <JourneyColumn row={row} /> },
  {
    key: "status",
    label: "STATUS",
    width: 110,
    headerStyle: { textAlign: "center" },
    cellStyle: { textAlign: "center", verticalAlign: "middle" },
    render: (row) => <StatusColumn row={row} />,
  },
  {
    key: "created_on",
    label: "CREATED",
    width: 100,
    render: (row) => <CreatedColumn row={row} value={row.payment_created_on || row.created_on} />,
  },
  {
    key: "view_traveller",
    label: "View traveller",
    width: 110,
    stopRowClick: true,
    render: (row) => <TravellerUploadDocCell row={row} />,
  },
];
